
var $ = require("jquery");
//require('is-in-viewport');
var InView = require('inview');


export function lazyLoadImages() {

    $(document).ready(function () {

        let elements = $("img[data-src], [data-bg-src], [data-lazy-react]");
        //let elementsBg = $("img[data-bg-src]");

        let inviewElements = [];

        elements.each(function (index, el) {

            var invewEl = InView(el, function (isInView, data) {
                //console.log('InView', data, invewEl, this);

                if (isInView) {

                    if (loadRealImage(el))
                        this.destroy();

                    if (data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
                        //statusHtml('status: <span class="success">in view</span> (top half)')
                    } else {
                        //statusHtml('status: <span class="success">in view</span> (bottom half)')
                    }
                } else {
                    if (data.windowScrollTop - (data.elementOffsetTop - data.inViewHeight) > data.inViewHeight) {

                        if (data.elementOffsetTopInViewHeight - data.inViewHeight < 200) {
                            if (loadRealImage(el))
                                this.destroy();
                        }
                    } else {
                        //statusHtml('status: <span class="fail">not in view</span> (scroll down)')
                    }
                }

            });

        });

    })

    function loadRealImage(el) {

        var $this = $(el);

        if ($this.data('lazy-react')) {
            $(document).trigger('custom-lazy-react-load', [$this.attr('id')]);
            return true;
        }

        var elSrc = $this.data('src') || '';
        var elBgSrc = $this.data('bg-src') || '';

        var addedSrc = false;
        var addedBgSrc = false;

        if (elSrc.length > 0) {
            $this.attr('src', elSrc);
            addedSrc = true;
        }

        if (elBgSrc.length > 0) {
            $this.css('background-image', 'url("' + elBgSrc + '")')
            elBgSrc = true;
        }

        return addedSrc || addedBgSrc;
    }
}